"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const react_1 = require("react");
const styles_1 = require("./styles");
const Tooltip = ({ children, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, { ...props, "data-testid": "tooltip", slots: {
            tooltip: styles_1.TooltipPopper
        }, slotProps: {
            popper: {
                // This zIndex style override is needed because when a tooltip popper
                // is rendered within another popper element
                // (e.g. modal), the tooltip is not visible.
                style: { zIndex: "1500" }
            }
        }, ref: ref, children: children }));
};
exports.default = (0, react_1.forwardRef)(Tooltip);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVG9vbHRpcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90b29sdGlwL1Rvb2x0aXAudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLG9FQUErQztBQUMvQyxpQ0FBbUM7QUFDbkMscUNBQXlDO0FBS3pDLE1BQU0sT0FBTyxHQUFHLENBQ2QsRUFBRSxRQUFRLEVBQUUsR0FBRyxLQUFLLEVBQVMsRUFDN0IsR0FBc0MsRUFDdEMsRUFBRTtJQUNGLE9BQU8sQ0FDTCx1QkFBQyxpQkFBVSxPQUNMLEtBQUssaUJBQ0ksU0FBUyxFQUN0QixLQUFLLEVBQUU7WUFDTCxPQUFPLEVBQUUsc0JBQWE7U0FDdkIsRUFDRCxTQUFTLEVBQUU7WUFDVCxNQUFNLEVBQUU7Z0JBQ04scUVBQXFFO2dCQUNyRSw0Q0FBNEM7Z0JBQzVDLDRDQUE0QztnQkFDNUMsS0FBSyxFQUFFLEVBQUUsTUFBTSxFQUFFLE1BQU0sRUFBRTthQUMxQjtTQUNGLEVBQ0QsR0FBRyxFQUFFLEdBQUcsWUFFUCxRQUFRLEdBQ0UsQ0FDZCxDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsa0JBQWUsSUFBQSxrQkFBVSxFQUFDLE9BQU8sQ0FBQyxDQUFDIn0=